module.exports = __webpack_public_path__ + "img/MenuButton_JQ.eb1de158.png";